<template>
  <iframe src="https://anmeldung.csn.de/dmb-rechtsschutz"
          width="100%"
          height="1930"
          style="border:none;" />
</template>
<script>
export default {
  name: "OnlineschulungPage",
  computed: {}
};

</script>
<style>

</style>
